'use es6';

import http from 'hub-http/clients/apiClient';
import formatPersonas from 'reference-resolvers/formatters/formatPersonas';
export const createGetAllPersonas = ({
  httpClient
}) => () => httpClient.get('contacts/v1/personas').then(formatPersonas);
export const getAllPersonas = createGetAllPersonas({
  httpClient: http
});